<template>
    <router-link :to="url">
        <div class="coverLink__container default" :style="background">
            <div class="coverLink">
                <div :class="`coverLink__panel ${this.uuid}`" :style="color_vars">
                    <div class="coverLink__header">
                        {{ header }}
                    </div>
                </div>
            </div>
        </div>
        <div class="coverLink__container mobile" :style="background_mobile">
            <div class="coverLink">
                <div :class="`coverLink__panel ${this.uuid}`" :style="color_vars">
                    <div class="coverLink__header">
                        {{ header }}
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: "WidgetCoverLink",
        props: {
            uuid: String,
            image: Object,
            header: String,
            color: String,
            url: String
        },
        mounted() {
            // Set color for ie
            document.styleSheets[0].addRule(`.${this.uuid}:after`, `background-color: ${this.color}`, 0);
        },
        computed: {
            background() {
                return {
                    'background-image': `url('${this.image.default.src}')`
                }
            },
            background_mobile() {
                return {
                    'background-image': `url('${this.image.mobile.src}')`
                }
            },
            color_vars() {
                return {
                    '--color': this.color,
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../node_modules/bootstrap/scss/functions";
    @import "../assets/styles/CustomVariables";
    @import "../../node_modules/bootstrap/scss/variables";
    @import "../../node_modules/bootstrap/scss/mixins";
    // @import "../../node_modules/bootstrap/scss/reboot"
    @import "../../node_modules/bootstrap/scss/grid";

    .coverLink__container {
        position: relative;
        width: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        @include media-breakpoint-down(md) {
            margin-top: 1rem;
            background-size: 100% auto;
        }

        &.mobile {
            display: none;
        }

        @include media-breakpoint-down(sm) {
            &.default {
                display: none;
            }
            &.mobile {
                display: block;
            }
        }


        &:after {
            content: "";
            display: block;
            padding-bottom: 100%;
            @include media-breakpoint-down(sm) {
                padding-bottom: 50%;
            }
        }

        .coverLink {
            position: absolute;
            width: 100%;
            height: 100%;

            &:hover .coverLink__panel {
                padding-bottom: 10%;
                @include media-breakpoint-down(sm) {
                    padding-bottom: 5%;
                }

                height: 30%;
                @include media-breakpoint-down(md) {
                    padding-bottom: 20%;
                    height: 60%;
                }
                @include media-breakpoint-down(sm) {
                    padding-bottom: 5%;
                    height: 30%;
                }
                transition: height 0.3s ease-out, padding-bottom 0.4s ease-out;
            }

            &__panel {
                transition: height 0.3s ease-in, padding-bottom 0.4s ease-in;
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 25%;
                @include media-breakpoint-down(md) {
                    height: 45%;
                }
                @include media-breakpoint-down(sm) {
                    height: 3rem;
                }

                &::after {
                    content: '';
                    width: 100%;
                    height: 100%;
                    background-color: var(--color);
                    opacity: 0.85;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 1;
                }
            }

            &__header {
                font-weight: bold;
                position: relative;
                text-align: center;
                display: flex;
                justify-content: center;
                align-content: center;
                flex-direction: column;
                height: 100%;
                font-size: 2rem;
                color: white;
                z-index: 2;
                @include media-breakpoint-down(md) {
                    font-size: 1.5rem;
                }
            }
        }
    }
</style>
